import { accountService } from "../services/accountService";
import axios, { AxiosRequestConfig } from "axios";

const get = async (url: string) => {
  let response = await axios.get(url);
  return response.data;
};

const getWithBody = async (url: string, body: any) => {
  const requestOptions: AxiosRequestConfig<any> = {
    params: body,
  };
  const response = await axios.get(url, requestOptions);
  return response.data;
};

const post = async (url: string, body: any) => {
  const requestOptions: any = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    data: JSON.stringify(body),
  };
  let response = await axios(url, requestOptions);
  return response.data;
};

function put(url: string, body: any) {
  const requestOptions: any = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions).then(handleResponse);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(url: string) {
  const requestOptions: any = {
    method: "DELETE",
  };
  return fetch(url, requestOptions).then(handleResponse);
}

const handleResponse = async (response: Response) => {
  let text = await response.text();
  const data = text && JSON.parse(text);
  if (!response.ok) {
    if ([401, 403].includes(response.status) && accountService.userValue) {
      // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
      //    accountService.logout();
    }

    const error = (data && data.message) || response.statusText;
    return new Error(error);
  }
  return data;
};

export const axiosWrapper = {
  get,
  post,
  put,
  delete: _delete,
  getWithBody,
};
